import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'div[data-component-type=thankyou]',
  templateUrl: './thankyou.component.html',
  styleUrls: ['./thankyou.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ThankyouComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
